
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
var reEscapeChar = /\\(\\)?/g;
var MAX_SAFE_INTEGER = 9007199254740991;
var reIsUint = /^(?:0|[1-9]\d*)$/;

const stringToPath = (string) => {
  let result = [];
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
};

function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
};

const isKey = (value, object) => {
  return object != null && value in Object(object);
};

const isIndex = (value, length) => {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
};

const castPath = (value, object) => {
  if (value instanceof Array) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(value);
};

const assignValue = (object, key, value) => {
  var objValue = object[key];
  if (!(Object.prototype.hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
};

const eq = (value, other) => {
  return value === other || (value !== value && other !== other);
};


/**
 * _get
 * @param {*} object 
 * @param {*} path 
 * @param {*} defaultValue 
 */
export const _get = (object, path, defaultValue) => {

  const baseGet = (object, path) => {
    path = castPath(path, object);
    var index = 0,
        length = path.length;
    while (object != null && index < length) {
      object = object[path[index++]];
    }
    return (index && index == length) ? object : undefined;
  }

  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;

};

/**
 * _set
 * @param {*} object 
 * @param {*} path 
 * @param {*} value 
 */
export const _set = (object, path, value) => {

  const baseSet = (object, path, value, customizer) => {
    if (!isObject(object)) {
      return object;
    }
    path = castPath(path, object);
  
    var index = -1,
        length = path.length,
        lastIndex = length - 1,
        nested = object;
  
    while (nested != null && ++index < length) {
      var key = path[index],
          newValue = value;
  
      if (index != lastIndex) {
        var objValue = nested[key];
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
      assignValue(nested, key, newValue);
      nested = nested[key];
    }
    return object;
  }

  return object == null ? object : baseSet(object, path, value);
}

export const toArray = (value) => {
  return value instanceof Array ? value : [value];
}

const ObjectUtils = {
  get: _get,
  set: _set,
  toArray: toArray,
};

export default ObjectUtils;


// WEBPACK FOOTER //
// ../UmiCore/src/utils/ObjectUtils.js